import { useFlag } from '@calendly/feature-check-react'
import { useMemo } from 'react'

import { useGetOrganizationUuid } from 'common'
import { buildSupergraphInput } from 'features/meetings/hooks/search_data/supergraph_meeting_search_utils'

import {
  useGetMeetingsQuery as useGQLGetMeetingsQuery,
  useGetMeetingsSupergraphQuery,
} from '../graphql_api'

/**
 * "Same day" / badge list in the meeting detail right rail. Legacy path uses search GraphQL (/api/search).
 * When `sa_meetings_page_with_supergraph` is on, uses supergraph getMeetings instead.
 */
export function useGetMeetingsForMeetingDetail(legacyParams, options) {
  const useSupergraphList = useFlag('sa_meetings_page_with_supergraph', false)
  const organizationUuid = useGetOrganizationUuid()

  const supergraphInput = useMemo(() => {
    if (!legacyParams || !useSupergraphList || !organizationUuid) return null
    const ui = { ...legacyParams, organizationUuid }
    return buildSupergraphInput(ui, {
      today: Boolean(legacyParams.today),
      past: Boolean(legacyParams.past),
      first: 30,
      after: null,
      order: legacyParams.order || 'ASC',
    })
  }, [legacyParams, useSupergraphList, organizationUuid])

  const skip = Boolean(options?.skip)
  const skipLegacy = skip || useSupergraphList
  const skipSuper = skip || !useSupergraphList || !supergraphInput

  const legacy = useGQLGetMeetingsQuery(legacyParams, { ...options, skip: skipLegacy })
  const sup = useGetMeetingsSupergraphQuery(supergraphInput ?? {}, { ...options, skip: skipSuper })

  return useSupergraphList ? sup : legacy
}
